import { connectRouter } from "connected-react-router";
import { History } from "history";
import { combineReducers, Reducer, ReducersMapObject } from "redux";
import IStore from "../models/IStore";
import AgendaReducer from "./agenda/AgendaReducer";
import ConfigReducer from "./config/ConfigReducer";
import ErrorReducer from "./error/ErrorReducer";
import FeedbackReducer from "./feedback/FeedbackReducer";
import LookUpReducer from "./lookup/LookUpReducer";
import MenuReducer from "./menu/MenuReducer";
import MessaggioReducer from "./messaggio/MessaggioReducer";
import NotaReducer from "./note/NotaReducer";
import RequestingReducer from "./requesting/RequestingReducer";
import CercaReducer from "./ricerca/CercaReducer";
import SimulazioneReducer from "./simulazione/SimulazioneReducer";
import ToastsReducer from "./toasts/ToastsReducer";
import UtenteReducer from "./utente/UtenteReducer";
import EstimateReducer from "./estimate/EstimateReducer";
import DocumentsReducer from "./documents/DocumentsReducer";
import NotificheReducer from "./notifiche/NotificheReducer";
import PracticeReducer from "./pratica/PracticeReducer";
import CercaHeaderReducer from "./cerca-header/CercaHeaderReducer";
import IntegrationReducer from "./integration/IntegrationReducer";

export default (history: History): Reducer<IStore> => {
    const reducerMap: ReducersMapObject<IStore> = {
        error: ErrorReducer.reducer,
        requesting: RequestingReducer.reducer,
        router: connectRouter(history) as any,
        toasts: new ToastsReducer().reducer,
        feedback: new FeedbackReducer().reducer,
        menu: new MenuReducer().reducer,
        utente: new UtenteReducer().reducer,
        lookup: new LookUpReducer().reducer,
        simulazione: new SimulazioneReducer().reducer,
        config: new ConfigReducer().reducer,
        cerca: new CercaReducer().reducer,
        agenda: new AgendaReducer().reducer,
        messaggio: new MessaggioReducer().reducer,
        nota: new NotaReducer().reducer,
        estimate: new EstimateReducer().reducer,
        documents: new DocumentsReducer().reducer,
        notifiche: new NotificheReducer().reducer,
        practice: new PracticeReducer().reducer,
        cercaHeader: new CercaHeaderReducer().reducer,
        integration: new IntegrationReducer().reducer,
    };

    return combineReducers(reducerMap);
};
